var _defs, _rect, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG04(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.945,
    height: 80.948,
    viewBox: "0 0 80.945 80.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.948,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.948,
    fill: "#c41a2e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.249,18.316,12.7,11.6h.024v6.717ZM12.681,23.1h2.6V20.457h1.108V18.316H15.281V6.784h-2.7L7.843,18.771v1.686h4.838Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.894,43.4,21.377,35.02V62.138l14.517,4.38Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.49,43.458V66.527L52.1,62.134V35.021Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5,34.334a1.718,1.718,0,1,0-3.435,0v1.851H63.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.49,61.657h-.426l1.718,6,1.715-6h0V37.53H60.063V61.657Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.22,36.185l-1.556-1.23V62.873L37.533,68.086H35.894L19.835,63.6V34.955l-1.557,1.23V64.691L35.82,69.547h1.786l16.185-5.138,1.429-.421Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.115,16.479h2.654v.907H24.227V19.28h1.1v.9h-1.1v2.01h1.542v.907H23.115Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.024,22.186c.458,0,.634-.273.634-.673V18.05a.579.579,0,0,0-.634-.663h-.469v4.8Zm1.746-3.931v3.063c0,1.015-.42,1.775-1.61,1.775H26.443V16.479H28.16c1.19,0,1.61.752,1.61,1.776",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.731,16.479v5c0,1.025-.439,1.688-1.57,1.688A1.492,1.492,0,0,1,30.5,21.484v-5h1.112v5.113c0,.39.156.653.547.653s.546-.263.546-.653V16.479Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.464,21.386v-3.2A1.56,1.56,0,0,1,36.123,16.4c1.229,0,1.57.683,1.57,1.658v.781H36.679v-.868c0-.41-.137-.644-.537-.644s-.566.283-.566.683v3.551c0,.4.166.682.566.682s.537-.253.537-.643v-1.22h1.014v1.141c0,.947-.39,1.649-1.57,1.649a1.564,1.564,0,0,1-1.659-1.785",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.44,21h.888l-.439-2.655h-.01Zm-1.4,2.1,1.249-6.614h1.268l1.259,6.614H40.679l-.205-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.675,16.479h2.956v.907h-.917v5.707H42.592V17.387h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(45.247 16.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.354,21.562V18.011c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682M47.1,21.386v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.136,18.938v4.156H51.2V16.48h1.093l1.2,3.794V16.48h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.369,11.916V8.307c0-.4-.175-.683-.575-.683s-.566.283-.566.683v3.609c0,.39.176.683.566.683s.575-.293.575-.683m-.985,1.922v-.449a1.521,1.521,0,0,1-1.268-1.707v-3.2a1.685,1.685,0,1,1,3.365,0v3.2a1.588,1.588,0,0,1-.819,1.561l.819.156v.829Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.433,6.775v5c0,1.025-.439,1.687-1.57,1.687A1.492,1.492,0,0,1,27.2,11.78v-5h1.112v5.113c0,.39.156.653.547.653s.546-.263.546-.653V6.775Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.249,11.293h.888L32.7,8.638h-.01Zm-1.4,2.1L32.1,6.775h1.268l1.259,6.614H33.488l-.2-1.21H32.1l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.167,6.775h1.112v5.707h1.327v.907H35.167Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(38.123 6.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.753,6.775h2.956v.907h-.917V13.39H40.67V7.683h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.412,10.873V13.39H44.3V10.873l-1.239-4.1h1.161L44.9,9.283h.01l.673-2.507h1.063Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG04);
export default __webpack_public_path__ + "static/media/G04.e22ed33bdb24f42dc0b9aa31f893578a.svg";
export { ForwardRef as ReactComponent };